export default [
    {
        code: 'aged-balance',
        keyName: 'report.reportBanner.labels.aged_balance',
        id: '0ca65282-4db0-438d-9819-50ff49d61bdc',
        oldReportsCode: ['reconciliationStat'],
        pricingLevels: [3, 4, 5],
        pricingPlans: ['essential', 'advanced', 'enterprise', 'standard', 'evolution', 'elite'],
        licenses: ['pack_invoicing_management', 'pack_all_included'],
    },
    {
        code: 'opportunities-distribution-by-step-and-pipeline',
        keyName: 'report.reportBanner.labels.opportunities_distribution_by_step_and_pipeline',
        id: 'd3e384bc-2e82-48a8-b139-e0db624f70af',
        oldReportsCode: ['reportprevsales', 'opportunity', 'prospection'],
        pricingLevels: [3, 4, 5],
        pricingPlans: ['essential', 'standard'],
        licenses: ['pack_prospecting_sale', 'pack_all_included'],
    },
    {
        code: 'opportunities-distribution-by-step-and-pipeline-by-staff',
        keyName:
            'report.reportBanner.labels.opportunities_distribution_by_step_and_pipeline_by_staff',
        id: 'dc414e56-d3f7-43ce-97d5-53adb8c1d9da',
        oldReportsCode: ['reportprevsales', 'opportunity', 'prospection'],
        pricingLevels: [4, 5],
        pricingPlans: ['advanced', 'enterprise', 'evolution', 'elite'],
        licenses: ['pack_prospecting_sale', 'pack_all_included'],
    },
    {
        code: 'opportunities-evolution',
        keyName: 'report.reportBanner.labels.opportunities_evolution',
        id: '20012c23-6bc7-4d34-9bcc-674dbe5709bf',
        oldReportsCode: ['opportunity', 'prospection'],
        pricingLevels: [4, 5],
        pricingPlans: ['advanced', 'enterprise', 'evolution', 'elite'],
        licenses: ['pack_all_included'],
    },
    {
        code: 'opportunities-evolution',
        keyName: 'report.reportBanner.labels.opportunities_evolution',
        id: '20012c23-6bc7-4d34-9bcc-674dbe5709bf',
        oldReportsCode: ['source'],
        pricingLevels: [4, 5],
        pricingPlans: ['advanced', 'enterprise', 'evolution', 'elite'],
        licenses: ['pack_prospecting_sale', 'pack_all_included'],
    },
    {
        code: 'opportunity-won-conversion-rate',
        keyName: 'report.reportBanner.labels.opportunity_won_conversion_rate',
        id: '90db5570-375a-4c89-9ef4-14dafc124691',
        oldReportsCode: ['opportunity', 'prospection'],
        pricingLevels: [3, 4, 5],
        pricingPlans: ['essential', 'standard'],
        licenses: ['pack_prospecting_sale', 'pack_all_included'],
    },
    {
        code: 'opportunity-won-by-staff-conversion-rate',
        keyName: 'report.reportBanner.labels.opportunity_won_by_staff_conversion_rate',
        id: '4485fb79-ec98-4489-b3c9-ec908d69d657',
        oldReportsCode: ['opportunity', 'prospection'],
        pricingLevels: [4, 5],
        pricingPlans: ['advanced', 'enterprise', 'evolution', 'elite'],
        licenses: ['pack_prospecting_sale', 'pack_all_included'],
    },
    {
        code: 'opportunity-lost-won-detailed',
        keyName: 'report.reportBanner.labels.opportunity_lost_won_detailed',
        id: '648f3662-b40e-48b7-87f7-0ef199c07bd6',
        oldReportsCode: ['opportunity', 'prospection'],
        pricingLevels: [4, 5],
        pricingPlans: ['advanced', 'enterprise', 'evolution', 'elite'],
        licenses: ['pack_all_included'],
    },
    {
        code: 'products-services-sales',
        keyName: 'report.reportBanner.labels.products_services_sales',
        id: 'f6ac68fe-bd61-41f4-8aa2-c8788d7fc2d2',
        oldReportsCode: ['sales_by_customer', 'salestatsCatalog'],
        pricingLevels: [4, 5],
        pricingPlans: ['advanced', 'enterprise', 'evolution', 'elite'],
        licenses: ['pack_invoicing_management', 'pack_all_included'],
    },
    {
        code: 'opportunities-rentability',
        keyName: 'report.reportBanner.labels.opportunities_rentability',
        id: '86b60130-c098-4b8f-94b6-bd6ce7c873f9',
        oldReportsCode: ['prospection', 'margin'],
        pricingLevels: [5],
        pricingPlans: ['evolution', 'elite'],
        licenses: ['pack_all_included'],
    },
    {
        code: 'catalogue-margin-rate',
        keyName: 'report.reportBanner.labels.catalogue_margin_rate',
        id: 'c5ffff08-3248-4793-a9e9-a32f85b8ea3f',
        oldReportsCode: ['margin'],
        pricingLevels: [3, 4, 5],
        pricingPlans: ['essential', 'advanced', 'enterprise', 'standard', 'evolution', 'elite'],
        licenses: ['pack_invoicing_management', 'pack_all_included'],
    },
    {
        code: 'margin-rate-realized',
        keyName: 'report.reportBanner.labels.margin_rate_realized',
        id: 'ba183059-54f8-4acc-b01d-439a13b9817a',
        oldReportsCode: ['margin'],
        pricingLevels: [4, 5],
        pricingPlans: ['essential', 'standard'],
        licenses: ['pack_invoicing_management', 'pack_all_included'],
    },
    {
        code: 'margin-rate-realized-by-staff',
        keyName: 'report.reportBanner.labels.margin_rate_realized_by_staff',
        id: '19a88f9b-fc1e-46c0-97a5-54aaf5aeee0d',
        oldReportsCode: ['margin'],
        pricingLevels: [4, 5],
        pricingPlans: ['advanced', 'enterprise', 'evolution', 'elite'],
        licenses: ['pack_invoicing_management', 'pack_all_included'],
    },
    {
        code: 'turnover-global',
        keyName: 'report.reportBanner.labels.turnover_global',
        id: '61b4b719-893d-453b-91b2-808f4d8ead5b',
        oldReportsCode: ['sales'],
        pricingLevels: [3, 4, 5],
        pricingPlans: ['essential', 'standard'],
        licenses: ['pack_invoicing_management', 'pack_all_included'],
    },
    {
        code: 'turnover-global-by-staff',
        keyName: 'report.reportBanner.labels.turnover_global_by_staff',
        id: '88c4e451-67b3-4b62-b3a4-d946ace69b48',
        oldReportsCode: ['sales'],
        pricingLevels: [4, 5],
        pricingPlans: ['advanced', 'enterprise', 'evolution', 'elite'],
        licenses: ['pack_invoicing_management', 'pack_all_included'],
    },
];
